import enableDefaultOnlineMeeting from './enableDefaultOnlineMeeting';
import { clearOnlineMeeting } from 'owa-calendar-compose-form-actions';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import launchThirdPartyOnlineMeetingProvider from './launchThirdPartyOnlineMeetingProvider';
import { isFeatureEnabled } from 'owa-feature-flags';
import isDefaultOnlineMeetingProviderThirdParty from 'owa-calendar-event-option/lib/utils/isDefaultOnlineMeetingProviderThirdParty';

/**
 * Updates the online meeting when the user adds or removes attendees
 * @param event
 */
export default function updateOnlineMeetingOnRecipientsChanged(
    hostItemIndex: string,
    event: CalendarEvent,
    formId: string
) {
    /* If the defaultOnlineMeetingProvider is a 3P addin then only try to auto launch
        the addin. Else go ahead with the default 1P behaviour
        Flight 'addin-everyMeetingOnlineTestAutoLaunch' is added for testing purpose
        It is to be removed after cal server starts sending 3P addins
    */
    if (
        isFeatureEnabled('addin-everyMeetingOnline') &&
        (isDefaultOnlineMeetingProviderThirdParty() ||
            isFeatureEnabled('addin-everyMeetingOnlineTestAutoLaunch'))
    ) {
        launchThirdPartyOnlineMeetingProvider(hostItemIndex, event, formId);
    } else {
        // Decides whether to enable the online meeting by default or not
        enableDefaultOnlineMeeting(event, formId);
    }

    // Decides whether to clear the online meeting or not
    // Applicable for quick compose when the user removes all attendees and the online meeting disappears
    clearOnlineMeeting(event, formId);
}
